(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
 class StickyHeader extends HTMLElement {
  constructor() {
    super();

    this.onScrollHandler = this.onScroll.bind(this);
    this.onResizeHandler = this.onResize.bind(this);
  }

  connectedCallback() {
    // 当前 <sticky-header> 自己就是需要固定的元素
    this.header = this;

    // 里面真正的 header
    this.headerInner = this.querySelector('header');

    if (!this.headerInner) return;

    this.predictiveSearch = this.querySelector('predictive-search');

    // 记录 header 原始位置
    this.originalTop =
      this.getBoundingClientRect().top + window.scrollY;

    this.headerHeight = this.offsetHeight;

    document.documentElement.style.setProperty(
      '--header-height',
      `${this.headerHeight}px`
    );

    // 创建占位元素
    // fixed 后元素会脱离文档流，用它防止页面突然向上跳
    this.placeholder = document.createElement('div');
    this.placeholder.className = 'sticky-header-placeholder';
    this.placeholder.style.display = 'none';
    this.placeholder.style.height = `${this.headerHeight}px`;

    this.parentNode.insertBefore(
      this.placeholder,
      this
    );

    window.addEventListener(
      'scroll',
      this.onScrollHandler,
      {
        passive: true
      }
    );

    window.addEventListener(
      'resize',
      this.onResizeHandler
    );

    // 页面刷新时可能本身已经有滚动距离
    this.onScroll();
  }

  onScroll() {
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop;

    // 搜索框打开时不干扰
    if (
      this.predictiveSearch &&
      this.predictiveSearch.isOpen
    ) {
      return;
    }

    // 超过 Header 原来的位置
    if (scrollTop > this.originalTop) {
      this.fixHeader();
    } else {
      this.resetHeader();
    }
  }

  fixHeader() {
    if (
      this.classList.contains(
        'custom-header-fixed'
      )
    ) {
      return;
    }

    // 显示占位，防止页面跳动
    if (this.placeholder) {
      this.placeholder.style.display = 'block';
      this.placeholder.style.height =
        `${this.offsetHeight}px`;
    }

    this.classList.add(
      'custom-header-fixed'
    );

    // 清除 Dawn 可能留下来的状态
    this.classList.remove(
      'shopify-section-header-hidden'
    );
  }

  resetHeader() {
    this.classList.remove(
      'custom-header-fixed',
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'scrolled-past-header',
      'animate'
    );

    if (this.placeholder) {
      this.placeholder.style.display = 'none';
    }
  }

  onResize() {
    this.headerHeight = this.offsetHeight;

    document.documentElement.style.setProperty(
      '--header-height',
      `${this.headerHeight}px`
    );

    if (this.placeholder) {
      this.placeholder.style.height =
        `${this.headerHeight}px`;
    }

    // 非 fixed 状态重新计算原始位置
    if (
      !this.classList.contains(
        'custom-header-fixed'
      )
    ) {
      this.originalTop =
        this.getBoundingClientRect().top +
        window.scrollY;
    }
  }

  disconnectedCallback() {
    window.removeEventListener(
      'scroll',
      this.onScrollHandler
    );

    window.removeEventListener(
      'resize',
      this.onResizeHandler
    );

    if (this.placeholder) {
      this.placeholder.remove();
    }
  }
}

customElements.define(
  'sticky-header',
  StickyHeader
);

  } catch(e) { console.error(e); }
})();
})();
